import styled from 'styled-components';

export const StyledMap = styled('div')`
  font-family: ${(props) => props.theme.fontText};
  background-color: ${({ theme }) => theme.whiteSmoke};

  .map-wrap {
    position: relative;
    height: 70dvh;

    @media (max-width: 1600px) {
      height: 65dvh;
    }
    @media (max-width: 1440px) {
      height: 60dvh;
    }

    .zoom-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;

      .zoom-container-in {
        margin: 15px 0;
      }

      .zoom-container-out {
        margin: 0 15px 0 0;
      }
    }

    .on-map-btn-wrapper {
      position: relative;

      .on-map-btn {
        position: absolute;
        left: 30px;
        bottom: 30px;
      }
    }
  }

  .wrapper {
    @media (max-width: 1600px) {
      height: 65dvh;
    }
    @media (max-width: 1440px) {
      height: 60dvh;
    }

    .form-container {
      display: flex;
      justify-content: center;
      height: 65dvh;
      top: 165px;
      left: 20px;
      padding: 20px;
      border-radius: 10px;
      z-index: 100 !important;

      .ant-form {
        display: flex;
        min-width: 100%;
        max-width: 100%;
        justify-content: center;

        .categories-form {
          width: 100%;
        }

        .ant-select-selector {
          width: 100%;
        }

        .ant-select {
          min-width: 100%;
          max-width: 100%;
        }

        .ant-form-item-control-input-content {
          width: 100%;

          .ant-checkbox-group {
            width: 100%;
          }
        }

        .clear-filters-button-wrapper {
          margin-bottom: 8px;

          .ant-btn {
            height: 52px;
            border-color: ${({ theme }) => theme.colorText};
            border-radius: 25px;
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.colorText};

            &:hover {
              background-color: ${({ theme }) => theme.lightGrey};
              border-color: ${({ theme }) => theme.colorText};
              color: ${({ theme }) => theme.colorText};
            }
          }
        }

        .close-btn-wrapper {
          display: flex;
          justify-content: center;

          button {
            width: 100%;
          }
        }
      }

      @media (max-width: 1600px) {
        height: 65dvh;
      }
      @media (max-width: 1440px) {
        height: 60dvh;
      }
      overflow-y: scroll;
      width: 438px;
      z-index: 1;
      margin-left: 0;
    }
  }

  .back-to-list-btn-wrapper {
    padding: 10px 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .farms-list {
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 32px;
    justify-content: center;
    padding-top: 12px;
  }

  .form-container {
    position: absolute;
    z-index: 1000;
    margin-left: 40px;
    background-color: ${(props) => props.theme.white};
  }

  #map-popup {
    font-family: ${(props) => props.theme.fontText};
    position: relative;
    right: 90px;
  }

  .ant-pagination {
    padding-top: 50px;
    display: flex !important;
    justify-content: center !important;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      font-family: ${({ theme }) => theme.fontText} !important;
    }
  }

  .ant-pagination-item-link {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50% !important;
    transition: background-color 0.3s ease !important;
  }

  .ant-pagination-item-link:hover {
    background-color: ${({ theme }) => theme.lightGrey} !important;
  }

  .ant-pagination-item {
    border: none !important;
    background: transparent !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colorText} !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 32px !important;
    text-align: center !important;
    border-radius: 50% !important;
    transition: all 0.3s ease !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-pagination-item:not(.ant-pagination-item-active):hover {
    background-color: ${({ theme }) => theme.lightGrey} !important;
    color: ${({ theme }) => theme.colorText} !important;
  }

  .ant-pagination-item-active,
  .ant-pagination-item-active:hover {
    background-color: ${({ theme }) => theme.brand01} !important;
    border-color: ${({ theme }) => theme.brand01} !important;
    color: ${({ theme }) => theme.white} !important;
    font-weight: bold !important;
    border-radius: 50% !important;
  }

  .ant-pagination-item-active a,
  .ant-pagination-item-active:hover a {
    color: ${({ theme }) => theme.white} !important;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    color: ${({ theme }) => theme.colorText} !important;
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease !important;
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    outline: none !important;
    padding: 0 !important;
  }

  .ant-pagination-prev:hover,
  .ant-pagination-next:hover {
    background-color: ${({ theme }) => theme.lightGrey} !important;
  }

  .ant-pagination-prev.ant-pagination-disabled:hover,
  .ant-pagination-next.ant-pagination-disabled:hover {
    background-color: transparent !important;
  }

  .ant-pagination-prev {
    margin-inline-end: 0;
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 16px;
  }

  .ant-pagination-item-link span {
    color: ${({ theme }) => theme.paginationLink};
  }

  @media only screen and (max-width: 1305px) {
    .farms-list {
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    }
  }
`;
